import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmModal = ({
  show = true, title, labelCancel = null, labelConfirm = null, disabled = false, onConfirm, onClose, children
}) => {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={ false }>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={ onClose } type="button" className="btn btn-sm btn-default">{ labelCancel || 'Cancel' }</button>
        <button onClick={ onConfirm } disabled={ disabled } type="button" className="btn btn-sm btn-danger">{ labelConfirm || 'Yes' }</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ConfirmModal.jsx